import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import types from '../../types';
import notification from '../../../services/notification';

function* changePass({ payload }) {
  try {
    const { data, status } = yield call(api.setting.changePass, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_PASSWORD_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.UPDATE_PASSWORD_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getSecretKey() {
  try {
    const { data, status } = yield call(api.setting.getSecretKey);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_SECRET_KEY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_SECRET_KEY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* enableTwoFA({ payload }) {
  try {
    const { status } = yield call(api.setting.enableTwoFA, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.ENABLE_2FA_SUCCESS });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.ENABLE_2FA_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* disableTwoFA({ payload }) {
  try {
    const { status } = yield call(api.setting.disableTwoFA, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DISABLE_2FA_SUCCESS });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.DISABLE_2FA_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getBotUrl() {
  try {
    const { data, status } = yield call(api.setting.getBotUrl);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_BOT_URL_SUCCESS, payload: data });
    // notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.GET_BOT_URL_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateAdminChatId({ payload, setValue }) {
  try {
    const { status } = yield call(api.setting.updateAdminChatId, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_ADMIN_CHAT_ID_SUCCESS });

    notification({ type: 'success', message: 'Success' });
    setValue('');
  } catch (error) {
    yield put({ type: types.UPDATE_ADMIN_CHAT_ID_FAILURE });
    if (error?.response?.status === 401) return;
    if (
      error?.response?.data?.errors?.chat_id?.includes(
        'the_chat_id_must_be_an_integer',
      )
    ) {
      notification({
        type: 'error',
        title: 'Chat ID',
        message: 'Chat ID must be an integer format.',
      });
      setValue('');
      return;
    }

    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
    setValue('');
  }
}

export function* security() {
  yield all([
    takeLatest(types.UPDATE_PASSWORD_START, changePass),
    takeLatest(types.GET_SECRET_KEY_START, getSecretKey),
    takeLatest(types.DISABLE_2FA_START, disableTwoFA),
    takeLatest(types.ENABLE_2FA_START, enableTwoFA),
    takeLatest(types.GET_BOT_URL_START, getBotUrl),
    takeLatest(types.UPDATE_ADMIN_CHAT_ID_START, updateAdminChatId),
  ]);
}
